import { MessageCircle } from 'lucide-react';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t bg-muted/30 py-4 px-6">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-muted-foreground">
        <div className="flex items-center gap-4">
          <span>&copy; {currentYear} Built It CRM</span>
          <span className="hidden sm:inline">|</span>
          <a
            href="/help"
            className="hover:text-foreground transition-colors"
          >
            Help Center
          </a>
        </div>
        <button
          onClick={() => window.$chatwoot?.toggle('open')}
          className="flex items-center gap-1.5 hover:text-foreground transition-colors"
        >
          <MessageCircle className="h-3.5 w-3.5" />
          <span>Contact Support</span>
        </button>
      </div>
    </footer>
  );
}
